import { nextTick, onUnmounted, ref } from "vue";
import { onClickOutside } from "@vueuse/core";

export const useFloatingPreview = () => {
  const thumbnailRef = ref(null);
  const floatingRef = ref(null);
  const isPreviewVisible = ref(false);
  const isExpanded = ref(false);
  const floatingStyle = ref({});
  let stopClickOutside = null;
  let closeTimer = null;

  const openPreview = async () => {
    if (!thumbnailRef.value) return;
    clearTimeout(closeTimer);
    stopClickOutside?.();
    stopClickOutside = null;
    const rect = thumbnailRef.value.getBoundingClientRect();
    floatingStyle.value = {
      position: "absolute",
      top: `${rect.top + window.scrollY}px`,
      left: `${rect.left + window.scrollX}px`,
      width: `${rect.width}px`,
      height: `${rect.height}px`,
      zIndex: 10000,
    };
    isPreviewVisible.value = true;
    await nextTick();
    await new Promise(r => requestAnimationFrame(r));
    isExpanded.value = true;
    stopClickOutside = onClickOutside(thumbnailRef, closePreview, { ignore: [floatingRef] });
  };

  const closePreview = () => {
    isExpanded.value = false;
    stopClickOutside?.();
    stopClickOutside = null;
    closeTimer = setTimeout(() => {
      isPreviewVisible.value = false;
    }, 300);
  };

  onUnmounted(() => {
    stopClickOutside?.();
    stopClickOutside = null;
    clearTimeout(closeTimer);
  });

  return {
    thumbnailRef,
    floatingRef,
    isPreviewVisible,
    isExpanded,
    floatingStyle,
    openPreview,
    closePreview,
  };
};
